/* esm.sh - micromark-extension-gfm-tagfilter@2.0.0 */
export * from "/*micromark-extension-gfm-tagfilter@2.0.0/esnext/micromark-extension-gfm-tagfilter.mjs";
